import { FrameworkConfiguration } from 'aurelia-framework';
export abstract class Logger {
    public abstract debug(message: string, ...rest: any[]);
    public abstract info(message: string, ...rest: any[]);
    public abstract warn(message: string, ...rest: any[]);
    public abstract error(message: string, ...rest: any[]);
    public abstract async init(config: FrameworkConfiguration): Promise<void>;
}